import * as React from "react";

import mergeWith from "lodash/mergeWith";

import { ArticleTileProps } from "~/bff/components/ArticleTile";

import { ArticleTile } from "../article-tile/component";

import type { RelatedArticleTileProps } from "./types";

const getPreparedProps = (
  props: RelatedArticleTileProps,
): RelatedArticleTileProps => {
  return {
    ...props,
    title: props?.linkedBanner?.heading ?? props?.title,
    image: mergeWith(
      {},
      props?.image,
      props?.linkedBanner?.image,
      (objValue, srcValue) => srcValue ?? objValue,
    ),
  };
};

export const RelatedArticleTile = (
  props: RelatedArticleTileProps,
): React.ReactElement<ArticleTileProps> => (
  <ArticleTile {...getPreparedProps(props)} />
);
